import _regeneratorRuntime from "@babel/runtime/regenerator";
import _defineProperty from "@babel/runtime-corejs2/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime-corejs2/helpers/asyncToGenerator";

function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (_Object$getOwnPropertyDescriptors) { _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } } return target; }

import _Object$keys from "@babel/runtime-corejs2/core-js/object/keys";
import _Promise from "@babel/runtime-corejs2/core-js/promise";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs2/core-js/object/get-own-property-symbols";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs2/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs2/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs2/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs2/core-js/object/define-property";
import * as smConfig from '../lib/smSdk'; //默认配置

var SMDEFAULTCONFIG = {
  application: 'web',
  fpJsPath: '/ishumei/js/fp.min.js',
  apiPath: '/deviceprofile/v4',
  protocol: 'https' // 如果使用 https，则设置，如不使用，则不设置这个字段

};
/**
 * 获取数美数据
 * @param {*} config init初始化配置
 * @returns string
 */

export var fetchSmDeviceId = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var config,
        smDeviceId,
        __smConfig,
        _config$smConfig,
        _config$smConfig2,
        keys,
        smConfigKeys,
        sameKeys,
        isEquar,
        _yield$smConfig$fetch,
        success,
        data,
        deviceId,
        _args = arguments;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            config = _args.length > 0 && _args[0] !== undefined ? _args[0] : {};
            smDeviceId = '';

            if (!(config === null || config === void 0 ? void 0 : config.smConfig)) {
              _context.next = 22;
              break;
            }

            //检测数美配置
            keys = ['organization', 'appId', 'staticHost', 'publicKey']; // 'application'

            smConfigKeys = _Object$keys(config === null || config === void 0 ? void 0 : config.smConfig);
            sameKeys = keys.filter(function (_) {
              return smConfigKeys.includes(_);
            });
            isEquar = keys.sort().toString() === sameKeys.sort().toString();

            if (isEquar) {
              _context.next = 10;
              break;
            }

            console.error('请填写smConfig必填项');
            return _context.abrupt("return", smDeviceId);

          case 10:
            __smConfig = _objectSpread(_objectSpread(_objectSpread({}, SMDEFAULTCONFIG), config === null || config === void 0 ? void 0 : config.smConfig), {}, {
              fpJsPath: (config === null || config === void 0 ? void 0 : (_config$smConfig = config.smConfig) === null || _config$smConfig === void 0 ? void 0 : _config$smConfig.fpJsPath) || SMDEFAULTCONFIG.fpJsPath,
              protocol: (config === null || config === void 0 ? void 0 : (_config$smConfig2 = config.smConfig) === null || _config$smConfig2 === void 0 ? void 0 : _config$smConfig2.protocol) || SMDEFAULTCONFIG.protocol
            });
            _context.prev = 11;
            _context.next = 14;
            return smConfig.fetchDeviceId(__smConfig);

          case 14:
            _yield$smConfig$fetch = _context.sent;
            success = _yield$smConfig$fetch.success;
            data = _yield$smConfig$fetch.data;

            if (success) {
              //初始字符不为B则置空
              deviceId = (data === null || data === void 0 ? void 0 : data.deviceId.substr(0, 1)) === 'B' ? data === null || data === void 0 ? void 0 : data.deviceId : 'boxdata';
              smDeviceId = deviceId;
            }

            _context.next = 22;
            break;

          case 20:
            _context.prev = 20;
            _context.t0 = _context["catch"](11);

          case 22:
            return _context.abrupt("return", smDeviceId);

          case 23:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[11, 20]]);
  }));

  return function fetchSmDeviceId() {
    return _ref.apply(this, arguments);
  };
}();
/**
 * 获取当前数美数据
 */

export var getSmDeviceId = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
    var _window, _window$SMSdk, _window2, _window2$SMSdk;

    var reset,
        cb,
        deviceId,
        inited,
        _args2 = arguments;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            reset = _args2.length > 0 && _args2[0] !== undefined ? _args2[0] : false;
            cb = _args2.length > 1 && _args2[1] !== undefined ? _args2[1] : null;
            deviceId = '';
            inited = typeof ((_window = window) === null || _window === void 0 ? void 0 : (_window$SMSdk = _window.SMSdk) === null || _window$SMSdk === void 0 ? void 0 : _window$SMSdk.getDeviceId) === 'function';
            if (!inited) console.error('请先初始化sdk smConfig后再执行getSmDeviceId');
            deviceId = (_window2 = window) === null || _window2 === void 0 ? void 0 : (_window2$SMSdk = _window2.SMSdk) === null || _window2$SMSdk === void 0 ? void 0 : _window2$SMSdk.getDeviceId();
            if (reset) typeof cb === 'function' && cb(deviceId);
            return _context2.abrupt("return", deviceId);

          case 8:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function getSmDeviceId() {
    return _ref2.apply(this, arguments);
  };
}();
/**
 * 重置获取数美数据，会卡死暂时不重置
 */

export var resetSmDeviceId = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
    var smDeviceId, resolve, promise;
    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            smDeviceId = '';
            promise = new _Promise(function (res) {
              resolve = res;
            });
            smConfig.init(SMDEFAULTCONFIG).then( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
              var _yield$smConfig$fetch2, success, data;

              return _regeneratorRuntime.wrap(function _callee3$(_context3) {
                while (1) {
                  switch (_context3.prev = _context3.next) {
                    case 0:
                      _context3.next = 2;
                      return smConfig.fetchDeviceId();

                    case 2:
                      _yield$smConfig$fetch2 = _context3.sent;
                      success = _yield$smConfig$fetch2.success;
                      data = _yield$smConfig$fetch2.data;

                      if (success) {
                        _context3.next = 8;
                        break;
                      }

                      console.log('fetch deviceId failed');
                      return _context3.abrupt("return");

                    case 8:
                      smDeviceId = data.deviceId;
                      resolve(smDeviceId);
                      console.log("Is local deviceId: ".concat(!data.fromRemote, " ").concat(data.deviceId));

                    case 11:
                    case "end":
                      return _context3.stop();
                  }
                }
              }, _callee3);
            }))).catch(function () {
              resolve('');
              console.log('fetch deviceId failed');
            });
            return _context4.abrupt("return", promise);

          case 4:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));

  return function resetSmDeviceId() {
    return _ref3.apply(this, arguments);
  };
}();